import API from "../../Api";
import {
  DeliveryCharge,
  DeliveryChargeRequestBody,
  getDeliveryDetails,
} from "./DeliveryModels";
import { encryptJson } from "../..//utils/react-ec-utils";

export function getDeliveryChargeAPI(payload: DeliveryChargeRequestBody) {
  const requestPayload: DeliveryCharge = {
    pickupDetails: payload.pickupDetails,
    dropDetails: payload.dropDetails,
    locationId: payload.locationId,
    deliveryProviderId: payload.deliveryProviderId ?? "",
    receiverDetails:payload.receiverDetails,
    senderDetails: payload.senderDetails,
    tip: Math.floor(payload.tip),
    orderTotal: payload?.orderTotal,
    emailId: payload.emailId ?? "",
    mobileNo: payload.mobileNo ?? "",
    addressId: payload?.addressId ?? "",
    customerId: payload?.customerId ?? "",
  };
  
  const data = encryptJson(requestPayload);
  const ecnLocationProviderId = encryptJson(payload.deliveryProviderId);

  return API({
    method: "post",
    url: `/api/customers/delivery/quote?deliveryProviderId=${ecnLocationProviderId}`,
    data:{"data":data}
  });
}

export function dunzoOrderTrackingAPI(payload: getDeliveryDetails) {
  const data =encryptJson({"deliveryProviderId":payload?.DeliveryProviders,"orderId":payload?.orderId})
  return API({
    method: "post",
    url: `/api/customers/valet/getValetLocation`,
    data: {"data": data}
  });
}

// Instore Valet app tracking
export function getValetLocation(deliveryStaffId: string) {
  return API({
    method: "get",
    url: `/valet/getValetLocation?deliveryStaffId=${deliveryStaffId}`,
  });
}
